module.exports = __webpack_public_path__ + "static/TT1446_TW-MKD01_r1-add3c508ed668fac6d6356833ccfc980.png";